import actions from '../../actionTypes';

export default (orgId, orgUserRole) => {
  return {
    type: actions.GET_ORG_USER_ROLE,
    orgId,
    orgUserRole
  };
};



// WEBPACK FOOTER //
// ./src/reducers/organizations/actions/getOrgUserRole.js